import { Component, inject, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { UserManagementService } from "../services/user-management.service";
import { StorageHandlerService } from "../services";

@Component({
  selector: "mobi-office-lib-total-table-columns",
  templateUrl: "./total-table-columns.component.html",
  styleUrls: ["./total-table-columns.component.scss"],
  standalone: false,
})
export class TotalTableColumnsComponent {
  private readonly dialogRef = inject(MatDialogRef<TotalTableColumnsComponent>);
  private readonly toastr = inject(ToastrService);
  private readonly userManagementService = inject(UserManagementService);
  private readonly storageHandlerService = inject(StorageHandlerService);
  private data: TableColumnDialogData = inject(MAT_DIALOG_DATA);

  constructor() {
    this.dialogHandler(this.data);
  }

  columnMasterList: Cls_ColumnMaster[] = [];
  selectedColumnList: string[] = [];
  private IsActionFound = false;
  tableName = "";
  private UID = 0;

  private dialogHandler(data: TableColumnDialogData) {
    let { selectedColumn, totalColumns, tableName } = { ...data };
    this.UID = data.UID;
    this.tableName = tableName?.trim() || "";
    if (!selectedColumn?.length || !totalColumns?.length) {
      this.toastr.error("Columns Not Found", "Error");
      return;
    }

    //Find Action Column
    this.IsActionFound = totalColumns.find((x: any) => x.column === "Action") ? true : false;
    if (this.IsActionFound) totalColumns = totalColumns.filter((x: any) => x.column !== "Action");

    this.columnMasterList = totalColumns.map((item: any, index: number) => {
      const TempModal: Cls_ColumnMaster = {
        column: item.column,
        ColumnName: item.columnName,
        ColumnIndex: index,
        IsSelected: false,
      };
      if (selectedColumn.includes(item.column)) {
        TempModal.IsSelected = true;
      }
      return TempModal;
    });
    this.selectedColumnList = selectedColumn;
    this.columnMasterList.sort((x, y) => Number(y.IsSelected) - Number(x.IsSelected));
    this.selectedColumnList.forEach((element: string, index: number) => {
      const columnIndex = this.columnMasterList.findIndex((item: Cls_ColumnMaster) => item.column === element);
      if (columnIndex != -1) {
        this.array_move(this.columnMasterList, columnIndex, index);
      }
    });
  }

  array_move(arr: any[], old_index: number, new_index: number) {
    if (new_index >= arr.length) {
      let k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  }

  onDrag(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.columnMasterList, event.previousIndex, event.currentIndex);
  }

  private validateColumnList(): boolean {
    let isValid = true;
    let msg = "";

    const selectedColumnList = this.columnMasterList.filter(x => x.IsSelected);
    if (!selectedColumnList.length) {
      msg += "Please Select Atleast One Column";
    }

    if (msg) {
      this.toastr.error(msg, "Error");
      isValid = false;
    }

    return isValid;
  }

  onSubmit() {
    if (!this.validateColumnList()) return;
    const selectedColumnList = this.columnMasterList.filter(x => x.IsSelected);
    const selectedColumn = selectedColumnList.map(x => x.column);
    if (this.IsActionFound) selectedColumn.push("Action");
    if (this.tableName?.trim()) {
      this.updateColumn(selectedColumn);
    } else {
      this.dialogRef.close(selectedColumn);
    }
  }

  updateColumn(selectedColumn: string[]) {
    const column = this.storageHandlerService.getItem("TableColumns") || "[]";
    const columnList = JSON.parse(column);
    const tempModal = new Int_UserTableColumn();
    tempModal.UTCID = 0;
    tempModal.TableName = this.tableName;
    tempModal.UID = this.UID;
    tempModal.Columns = selectedColumn.join(",");
    tempModal.createdBy = this.UID;
    this.userManagementService.InsertUpdateUserTableColumn(tempModal).subscribe((res: any) => {
      const { Table } = res;
      tempModal.UTCID = Table;
      const currentList = columnList.filter((el: any) => el.TableName != tempModal.TableName);
      currentList?.push(tempModal);
      this.storageHandlerService.setItem("TableColumns", JSON.stringify(currentList));
      this.dialogRef.close(selectedColumn);
    });
  }
}

interface Cls_ColumnMaster {
  column: string;
  ColumnName: string;
  ColumnWidth?: string;
  ColumnBackground?: string;
  ColumnColor?: string;
  ColumnIndex: number;
  IsSelected: boolean;
}

interface TableColumnDialogData {
  selectedColumn: string[];
  totalColumns: string[];
  tableName?: string;
  mainColumns?: any[];
  UID: number;
}

class Int_UserTableColumn {
  UTCID?: number;
  UID?: number;
  TableName?: string;
  Columns?: string;
  IsActive?: boolean;
  createdAt?: Date;
  createdBy?: number;
  updatedAt?: Date;
  updatedBy?: number;
  deletedAt?: Date;
  deletedBy?: number;
}
